import { signInWithEmailAndPassword, AuthError } from 'firebase/auth';
import { auth } from '../../../../../config/firebase';
import { LoginFormInterface, FormDataErrorInterface } from '../../domain/interfaces/LoginInterface';
import { useNavigate } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from '../../../../../hooks';
import {
    setFormDataReducer,
    submitLoginStartReducer,
    submitLoginFailureReducer,
    clearLoginErrorReducer,
    setFormDataErrorReducer,
    setLoadingReducer
} from '../slice/LoginSlice';

const useLoginInfrastructure = () => {
    const dispatch = useAppDispatch();
    const loginState = useAppSelector(state => state.login);
    const navigate = useNavigate();

    const setLoginFormInfrastructure = (formData: Partial<LoginFormInterface>) => {
        dispatch(setFormDataReducer(formData));
    }

    const setFormDataErrorInfrastructure = (formDataError: Partial<FormDataErrorInterface>) => {
        dispatch(setFormDataErrorReducer(formDataError));
    }

    const clearLoginErrorInfrastructure = () => {
        dispatch(clearLoginErrorReducer());
    }

    const submitLoginInfrastructure = async () => {
        dispatch(submitLoginStartReducer());
        try {
            // 1. Llama a la función de Firebase para iniciar sesión
            await signInWithEmailAndPassword(auth, loginState.formData.email, loginState.formData.password);
            
            // 2. ¡Éxito! El usuario ha iniciado sesión.
            // Firebase gestiona la sesión automáticamente.
            navigate('/dashboard');
            // Aquí puedes redirigir al usuario al dashboard o a su perfil.
            // Por ejemplo: window.location.href = '/dashboard';

        } catch (err) {
            const authError = err as AuthError;
            switch (authError.code) {
                case 'auth/user-not-found':
                case 'auth/wrong-password':
                case 'auth/invalid-credential':
                    dispatch(submitLoginFailureReducer('El correo o la contraseña son incorrectos.'));
                    break;
                case 'auth/invalid-email':
                    dispatch(submitLoginFailureReducer('El formato del correo electrónico no es válido.'));
                    break;
                case 'auth/too-many-requests':
                    dispatch(submitLoginFailureReducer('Demasiados intentos fallidos. Por favor, intenta más tarde.'));
                    break;
                default:
                    dispatch(submitLoginFailureReducer('Ocurrió un error al intentar iniciar sesión.'));
                    break;
            }
        } finally {
            // 4. Se ejecuta siempre, al finalizar el try o el catch
            setLoadingReducer(false);
        }
    };

    return {
        setLoginFormInfrastructure,
        submitLoginInfrastructure,
        clearLoginErrorInfrastructure,
        setFormDataErrorInfrastructure,
        loginState
    }
}

export default useLoginInfrastructure;